import React, { useEffect, useState } from "react";
import "../App.css";
import { getResponse } from "../Service";
import HeroSection from "./HeroSection";
import MiddleSection from "./MiddleSection";
import Examples from "./pages/Examples";
import StaticCodeBlock from "./pages/StaticCodeBlock";
import DynamicCodeBlock from "./pages/DynamicCodeBlock";
import GroupScreen from "./pages/GroupScreen";

const Home = () => {
  const [askedQuestion, setAskedQuestion] = useState("");
  const [response, setResponse] = useState("");
  const [queryIndex, setQueryIndex] = useState(null);
  const [blackScreen, setBlackScreen] = useState(false);
  const [dynamicCodeSection, setDynamicCodeSection] = useState(false);
  const [allResponseScreen, setOpenAllResponseScreen] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [queryParams, setQueryParams] = useState("");

  const handleCloseButton = (newVal) => setBlackScreen(newVal);
  const handleCloseButtonInStatic = (val) => !val && setQueryIndex(null);
  const handleQueryIndexChange = (value) => setQueryIndex(value);
  const handleAskedQueryChange = (ques) => setAskedQuestion(ques);
  const handleCloseButtonInDynamic = (value) => setDynamicCodeSection(value);
  const handleCloseButtonInGroup = (value) => setOpenAllResponseScreen(value);

  const pageComponents = {
    1: (
      <>
        <HeroSection setBlackScreen={setBlackScreen} blackScreen={blackScreen} />
        <MiddleSection
          queryIndex={handleQueryIndexChange}
          setBlackScreen={setBlackScreen}
          blackScreen={blackScreen}
          allResponseScreen={allResponseScreen}
          setOpenAllResponseScreen={setOpenAllResponseScreen}
          setQueryParams={setQueryParams}
          setQueryIndex={setQueryIndex}
        />
      </>
    ),
    2: (
      <Examples
        allResponseScreen={allResponseScreen}
        onCrossButtonChange={handleCloseButton}
        queryIndex={handleQueryIndexChange}
        onQuesChange={handleAskedQueryChange}
        setBlackScreen={setBlackScreen}
        setOpenAllResponseScreen={setOpenAllResponseScreen}
        setQueryIndex={setQueryIndex}
        setPageNumber={setPageNumber}
        setQueryParams={setQueryParams}
        setDynamicCodeSection={setDynamicCodeSection}
      />
    ),
    3: (
      <StaticCodeBlock
        queryId={queryIndex}
        onQuesChange={handleAskedQueryChange}
        onCrossButtonChange={handleCloseButtonInStatic}
        setBlackScreen={setBlackScreen}
        setQueryIndex={setQueryIndex}
        setPageNumber={setPageNumber}
        setQueryParams={setQueryParams}
        setDynamicCodeSection={setDynamicCodeSection}
      />
    ),
    4: (
      <DynamicCodeBlock
        askedQuestion={askedQuestion}
        response={response}
        onQuesChange={handleAskedQueryChange}
        onCrossButtonChange={handleCloseButtonInDynamic}
        setBlackScreen={setBlackScreen}
        setQueryIndex={setQueryIndex}
        setPageNumber={setPageNumber}
        setQueryParams={setQueryParams}
        setDynamicCodeSection={setDynamicCodeSection}
      />
    ),
    5: (
      <GroupScreen
        onCrossButtonChange={handleCloseButtonInGroup}
        onQuesChange={handleAskedQueryChange}
        setBlackScreen={setBlackScreen}
        setQueryIndex={setQueryIndex}
        setPageNumber={setPageNumber}
        setQueryParams={setQueryParams}
        setDynamicCodeSection={setDynamicCodeSection}
      />
    ),
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const isQueryParams = params.has("q");
    const queryParams = params.get("q");
    setQueryParams(queryParams);

    if (isQueryParams) {
      if (queryParams === 'new') {
        setBlackScreen(true);
      } else {
      const pageIndexMapping = {
        '1': 1,
        '2': 2,
        '3': 3,
        '4': 4,
        'all': 5,
      };
      const pageIndex = pageIndexMapping[queryParams];
      if (pageIndex) {
        setQueryIndex(pageIndex);
        if (pageIndex === 5) {
          setOpenAllResponseScreen(true);
        }
      }
      }
    }
  }, []);

  useEffect(() => {
    setPageNumber((prevPageNumber) => {
      if (!allResponseScreen) {
        if (!blackScreen && !queryIndex && !dynamicCodeSection) return 1;
        if (blackScreen && !queryIndex && !dynamicCodeSection) return 2;
        if (!blackScreen && queryIndex && !dynamicCodeSection) return 3;
        if (!blackScreen && !queryIndex && dynamicCodeSection) return 4;
      } else {
        return 5;
      }
      return prevPageNumber;
    });
  }, [allResponseScreen, blackScreen, queryIndex, dynamicCodeSection]);

  useEffect(() => {
    if (askedQuestion) {
      setResponse("");
      setDynamicCodeSection(true);
      setQueryIndex(0);
      setBlackScreen(false);

      getResponse(askedQuestion)
        .then((response) => response.json())
        .then((result) => {
          setResponse({
            code: result.result,
          });
        })
        .catch(() => {
          setResponse({
            error: "Sorry unable to get the answer. Please try again.",
          });
        });
    }
  }, [askedQuestion]);

  return <>{pageComponents[pageNumber]}</>;
};

export default Home;
